import * as React from 'react';
import * as _ from 'lodash';

import { ITerm, IFacetResult } from '../../state-helpers/facets';

interface IProps {
    term: ITerm;
    onTermClick: () => void;
    showHits: boolean;
}

//This component takes a specific term and renders it as a toggle facet
export const ToggleFacetTerm = ({ term, onTermClick, showHits }: IProps) => {
    if (!term || term.hits === 0) {
        return null;
    }
    const divId = 'search-facet-' + (term.fieldName && term.fieldName.replace(/\s+/g, '-')).toLowerCase();

    return (
        <div className="search-facet-toggle-wrapper">
            <div className="search-facet-item search-facet-toggle form-element-toggle" id={divId}>
                <input
                    type="checkbox"
                    id={term.term}
                    name={term.term}
                    value={term.term}
                    className="form-element-toggle"
                    checked={term.selected}
                    onChange={onTermClick} />

                <label htmlFor={term.term}>

                </label>
                <div className="form-element-checkbox-text search-facet-toggle-text">
                    <h5>{term.displayTerm} {showHits ? `(${term.hits})` : ''}</h5>
                    <p>{term.description}</p>
                </div>
            </div>
        </div>
    );
}
